var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.product)?_c('div',[_c('ProductVariantDatatable',{attrs:{"product":_vm.product,"visibility":{ search: false }}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }